import { render, staticRenderFns } from "./AllWorkoutsViews.vue?vue&type=template&id=2fb1bef4&"
import script from "./AllWorkoutsViews.vue?vue&type=script&lang=js&"
export * from "./AllWorkoutsViews.vue?vue&type=script&lang=js&"
import style0 from "./AllWorkoutsViews.vue?vue&type=style&index=0&id=2fb1bef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports